import { KatIcon } from '@amzn/katal-react';
import React, { useContext } from 'react';
import styled from 'styled-components';
import {
  QuickLinkCustom,
  QuickLinkDropdown,
  QuickLinkItems,
  QuickLinkKatIcon,
  QuickLinkSvg,
  QuickLinkType,
} from './QuickLinkItems';
import { TranslationContext } from 'src/state/providers/TranslationProvider';
import { useLocalizationContext } from '@amzn/react-arb-tools';
import { AuthContext } from 'src/state/providers/AuthProvider';
import { fetchFromAppConfig } from 'src/config-store/ConfigFetcher';
import { CONFIG_TYPE } from 'src/constants/GlobalConstants';

export const FlexBodyCentered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.White};
`;

export const QuickLinkContainer = styled(FlexBodyCentered)`
  gap: 1.5em;
  a {
    fill: ${({ theme }) => theme.colors.White};
  }
`;

export const QuickLinkItemsContainer = styled.div`
  display: flex;
  font-size: ${({ theme }) => theme.fontSize.m};
  fill: ${({ theme }) => theme.colors.White};
`;

export const QuickLinkContent = styled(FlexBodyCentered)`
  gap: 0.25em;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'text')};
`;

type QuickLinksMenuItemsType = {
  items: (
    | QuickLinkKatIcon
    | QuickLinkDropdown
    | QuickLinkSvg
    | QuickLinkCustom
  )[];
};

export const QuickLinksMenuItems: React.FC<QuickLinksMenuItemsType> = ({
  items,
}) => {
  const { localizationContext } = useLocalizationContext();
  return (
    <>
      {items?.map((item) => {
        if (item.hidden && item.hidden == true) {
          return null;
        }

        switch (item.type) {
          case QuickLinkType.KAT_ICON:
            return (
              <QuickLinkItemsContainer
                key={item.id}
                data-testid="QuickLinksMenuItem"
              >
                <QuickLinkContent
                  onClick={() => item.onClick!(localizationContext.getLocale())}
                >
                  {item.description}
                  <KatIcon
                    name={item.iconName}
                    size="small"
                    title={item.description}
                  />
                </QuickLinkContent>
              </QuickLinkItemsContainer>
            );
          case QuickLinkType.SVG:
            return (
              <QuickLinkItemsContainer
                key={item.id}
                data-testid="QuickLinksMenuItem"
              >
                <QuickLinkContent
                  onClick={() => item.onClick!(localizationContext.getLocale())}
                >
                  {item.description}
                  {item.icon}
                </QuickLinkContent>
              </QuickLinkItemsContainer>
            );
          case QuickLinkType.CUSTOM:
            return (
              <QuickLinkItemsContainer
                key={item.id}
                data-testid="QuickLinksMenuItem"
              >
                <QuickLinkContent>
                  {item.displayName}
                  {item.icon}
                </QuickLinkContent>
              </QuickLinkItemsContainer>
            );
        }
      })}
    </>
  );
};

const QuickLinkMenu = () => {
  const { menuBundle } = useContext(TranslationContext);
  const { isAnonymousUser, preferredAccountId, clientId } =
    useContext(AuthContext);
  const menuItems = fetchFromAppConfig(
    preferredAccountId,
    clientId,
    CONFIG_TYPE.MENU,
  );

  const items =
    menuItems && menuItems?.rightMenuItems
      ? menuItems.rightMenuItems
      : QuickLinkItems(menuBundle, isAnonymousUser);

  return (
    <QuickLinkContainer>
      <QuickLinksMenuItems items={items} />
    </QuickLinkContainer>
  );
};

export default QuickLinkMenu;
